import { Injectable, inject, OnDestroy } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable, Subject } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface IdoBoughtEvent {
  idoSaleId: number;
  contractAddress: string;
  buyerAddress: string;
  tokenAmount: string;
  ethAmount?: string | null;
  issued?: string;
  txHash?: string | null;
  blockNumber?: number | null;
}

export interface IdoClaimedEvent {
  idoSaleId: number;
  contractAddress: string;
  buyerAddress: string;
  tokenAmount: string;
  claimed?: string;
  purchased?: string;
  txHash?: string | null;
}

@Injectable({ providedIn: 'root' })
export class EthereumSocketService implements OnDestroy {
  private socket: Socket | null = null;
  private readonly bought$ = new Subject<IdoBoughtEvent>();
  private readonly claimed$ = new Subject<IdoClaimedEvent>();

  connect(): void {
    const url = environment.ethereumApiUrl?.trim();
    if (!url || this.socket) {
      return;
    }
    this.socket = io(url, {
      transports: ['websocket', 'polling'],
      path: '/socket.io',
    });
    this.socket.on('idoBought', (payload: IdoBoughtEvent) =>
      this.bought$.next(payload),
    );
    this.socket.on('idoClaimed', (payload: IdoClaimedEvent) =>
      this.claimed$.next(payload),
    );
  }

  disconnect(): void {
    this.socket?.disconnect();
    this.socket = null;
  }

  onIdoBought(): Observable<IdoBoughtEvent> {
    this.connect();
    return this.bought$.asObservable();
  }

  onIdoClaimed(): Observable<IdoClaimedEvent> {
    this.connect();
    return this.claimed$.asObservable();
  }

  ngOnDestroy(): void {
    this.disconnect();
  }
}
